import { Component } from '@angular/core';
import { LanguageService, Language } from './language.service';
import { IconService } from './icon.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'NB-Platform';

  constructor(_2: IconService, languageService: LanguageService) {
    languageService.getLanguage().subscribe(language => {
      switch(language) {
        case 'dels':
          (document.querySelector(":root") as HTMLElement)?.style.setProperty('--dels-li-bottom-margin', '24px');
          break;
        default:
          (document.querySelector(":root") as HTMLElement)?.style.setProperty('--dels-li-bottom-margin', '0px');
          break;
      }
    });
  }
}
